//videos published by the IAPRL on YouTube. They are linked, never embedded: an embed would drop
//third party cookies on a public administration site and drag in a consent banner with it.
export const VIDEO_EXPLICATIVO_URL = 'https://www.youtube.com/watch?v=BxRah8FwXqc';
export const VIDEO_DIFUSION_URL = 'https://www.youtube.com/watch?v=cnubgA589Og';
